export default __webpack_public_path__ + "static/media/1844.7244308e.png";